import type { PartnerStatus } from "@redotech/admin-sdk/rpc/schema/partners/shared";
import { RedoBadge } from "@redotech/redo-web/arbiter-components/badge/redo-badge";
import { memo } from "react";

import { PARTNER_STATUS_BADGE_PROPS } from "../lib/partner-status-badge-props";

interface PartnerStatusBadgeProps {
  status: PartnerStatus;
  className?: string;
}

export const PartnerStatusBadge = memo(function PartnerStatusBadge({
  status,
  className,
}: PartnerStatusBadgeProps) {
  const props = PARTNER_STATUS_BADGE_PROPS[status];
  return (
    <RedoBadge className={className} color={props.color} text={props.text} />
  );
});
